// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Config          = require("./config");
var GiphyApiDecoder = require("./GiphyApiDecoder");

var reposUrl = "https://api.giphy.com/v1/gifs/search?q=futurama&limit=6&api_key=" + Config.apiKey;

function fetchGifs() {
  return fetch(reposUrl).then((function (prim) {
                  return prim.text();
                })).then((function (jsonText) {
                return Promise.resolve(GiphyApiDecoder.parseGiphyResponseJson(JSON.parse(jsonText)));
              }));
}

exports.reposUrl  = reposUrl;
exports.fetchGifs = fetchGifs;
/* GiphyApiDecoder Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/GiphyApi.re
// module id = 44
// module chunks = 0